import { motion } from 'framer-motion';
import { ArticleEntity } from 'graphql/blog/queries/article';
import { map } from 'lodash';
import { motionFadeIn } from 'utils';
import ArticleCard from '../article-card';

interface Props {
  articleList?: ArticleEntity[];
  onSelect?: (article: ArticleEntity) => void;
}

const ArticleList = ({ articleList, onSelect }: Props) => {
  const selectArticle = (article: ArticleEntity) => {
    onSelect?.(article);
  };

  return (
    <div id='article-list'>
      <ul className='-mx-[16px] -my-[20px] flex flex-wrap'>
        {map(articleList, (article, articleIndex) => (
          <motion.li
            key={articleIndex}
            variants={motionFadeIn('up', 'spring', articleIndex * 0.1, 2)}
            initial='hidden'
            whileInView='show'
            onClick={() => selectArticle(article)}
            className='w-1/3 cursor-pointer px-[16px] py-[20px]'
          >
            <ArticleCard article={article} />
          </motion.li>
        ))}
      </ul>
    </div>
  );
};

export default ArticleList;
